// packages import
import { Box, Button, CircularProgress, DialogActions, Typography } from "@mui/material"
import { FC, useContext } from "react"
// component import
import { Alert } from "../common/Alert"
import { CustomModal } from "../common/CustomModal"
// others
import { useDeleteCaseTypeMutation } from "../../../generated"
import { CANCEL } from "../../constants"
import { AppContext } from "../../context"
import { ActionType } from "../../context/AppContextReducer"
import { DispatchAndState } from "../../interfaceTypes"
import { titleize } from "../../utils"
import { LawTypeAction, LawTypeState } from "./LawTypeReducer"

export const DeleteCaseType: FC<DispatchAndState<LawTypeState, LawTypeAction>> = ({ state, refetch }) => {
  const { isDeleteOpen, dispatch } = useContext(AppContext)
  const { currentCaseType } = state || {}
  const { id, name } = currentCaseType || {}

  const [deleteCaseType, { loading }] = useDeleteCaseTypeMutation({
    onError(error) {
      const { graphQLErrors } = error

      if (graphQLErrors) {
        if (error.message === "Conflict Exception")
          Alert.error("Cannot delete case type with associated records")
        else
          Alert.error(error.message)
      }
    },

    onCompleted(data) {
      if (data) {
        const { deleteCaseType } = data
        const { response } = deleteCaseType || {}
        const { status } = response || {}

        if (status === 200) {
          refetch && refetch()
          Alert.success('Case type deleted successfully')
          handleClose();
          dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: false })
        }
      }
    }
  })

  const handleDelete = async () => {
    if (id) {
      await deleteCaseType({
        variables: {
          deleteCaseTypeInput: {
            id: id
          }
        }
      })
    }
  }

  const handleClose = () => dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: false })

  return (
    <CustomModal title="Delete Case Type" isOpen={isDeleteOpen} handleClose={handleClose}>
      <Typography variant="body1">You are about to delete the following case type:</Typography>

      <Box mt={1}>
        <Typography variant="body1" textTransform='capitalize'>
          <Typography component='span' fontWeight={500}>Title: </Typography> {titleize(name || '')}
        </Typography>
      </Box>

      <DialogActions sx={{ padding: '30px 0 0', flexWrap: 'wrap', }}>
        <Button onClick={handleClose} variant='outlined' aria-label={CANCEL}>{CANCEL}</Button>

        <Button
          disabled={loading}
          onClick={handleDelete} color='primary' variant="contained" aria-label='delete case type'
          endIcon={loading && <CircularProgress size={20} color="inherit" />}
        >
          Delete Case Type
        </Button>
      </DialogActions>
    </CustomModal>
  )
}